const COMPANY_DETAILS_PAYLOAD_FIELDS = [
  "id",
  "business_name",
  "subdomain",
  "business_arabic_name",
  "business_type_id",
  "business_type_verified",
  "cr",
  "is_vat_exempt",
  "vat",
  "round_off",
  "is_calories",
  "business_country",
  "business_postal_code",
  "business_region_id",
  "business_city_id",
  "business_address",
];

export const getCompanyAddressFormValues = (company = {}) => ({
  business_arabic_name: company.business_arabic_name,
  business_address: company.business_address,
  business_city_id: company.business_city?.id,
  business_region_id: company.business_region?.id,
  business_country: company.business_country || "Saudi Arabia",
  business_postal_code: company.business_postal_code,
});

export const hasCompleteCompanyBusinessAddress = (company = {}) => {
  return Boolean(
    company.business_country &&
      company.business_postal_code &&
      company.business_region &&
      company.business_city &&
      company.business_address,
  );
};

export const buildCompanyDetailsPayload = (formValues = {}) => {
  return COMPANY_DETAILS_PAYLOAD_FIELDS.reduce((payload, fieldName) => {
    if (Object.prototype.hasOwnProperty.call(formValues, fieldName)) {
      payload[fieldName] = formValues[fieldName];
    }

    return payload;
  }, {});
};

export const getBranchFormValues = (branch = {}) => ({
  id: branch.id,
  name: branch.name,
  business_address: branch.business_address,
  code: branch.code,
  ...(branch.zatca_profile
    ? {
        zatca_profile: {
          ...branch.zatca_profile,
          business_arabic_name:
            branch.zatca_profile.business_arabic_name,
        },
      }
    : {}),
});

export const buildBranchPayload = (formValues = {}) => {
  const businessFields = { ...formValues };
  const zatcaProfile = businessFields.zatca_profile;

  delete businessFields.address;
  delete businessFields.zatca_profile;

  if (!zatcaProfile) {
    return businessFields;
  }

  const businessZatcaProfile = { ...zatcaProfile };
  delete businessZatcaProfile.arabic_name;

  return {
    ...businessFields,
    zatca_profile: businessZatcaProfile,
  };
};
